import React from 'react';

const Transport = (props) => (
    <svg
        width="18px"
        height="18px"
        viewBox="0 0 18 18"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        {...props}
    >
        <title>Shipping 18</title>
        <desc>Created with Sketch.</desc>
        <g id="Shipping-18" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <rect id="boundry" x="0" y="0" width="18" height="18"></rect>
            <g id="icn_18_shipping" fill="#000000">
                <path
                    d="M15,13 C15,14.103 14.103,15 13,15 C11.897,15 11,14.103 11,13 L10.5,13 L7,13 C7,14.103 6.103,15 5,15 C3.897,15 3,14.103 3,13 L1,13 L1,3 L11,3 L11,6 L14.48,6 L17,8.519 L17,13 L15,13 Z M11.268,12 C11.615,11.403 12.261,11 13,11 C13.739,11 14.385,11.403 14.732,12 L16,12 L16,10 L14.5,10 C14.224,10 14,9.776 14,9.5 C14,9.224 14.224,9 14.5,9 L16,9 L16,8.934 L14.066,7 L11,7 L11,12 L11.268,12 Z M6.732,12 L10,12 L10,4 L2,4 L2,12 L3.268,12 C3.615,11.403 4.261,11 5,11 C5.739,11 6.385,11.403 6.732,12 L6.732,12 Z M5,12 C4.449,12 4,12.448 4,13 C4,13.552 4.449,14 5,14 C5.551,14 6,13.552 6,13 C6,12.448 5.551,12 5,12 L5,12 Z M13,12 C12.449,12 12,12.448 12,13 C12,13.552 12.449,14 13,14 C13.551,14 14,13.552 14,13 C14,12.448 13.551,12 13,12 L13,12 Z"
                    id="Color"
                ></path>
            </g>
        </g>
    </svg>
);

export default Transport;
